<template>

    <div class="home-notes">
      <p>* Website and Menu are under construction.</p>
    </div>    

    <div class="container-1">
      <div class="container-1-left">

        <div>
          <router-link to="/kimbap"> 
            <button class="text-kimbap">Kimbap</button>
          </router-link>
        </div>

        <div>
          <router-link to="/Bibimbap"> 
            <button class="text-bibimbap">Bibimbap</button>
          </router-link>
        </div>

        <div>
          <router-link to="/Bulgogi"> 
            <button class="text-bulgogi">Bulgogi</button>
          </router-link>
        </div>

        <div>
          <router-link to="/Tempura"> 
            <button class="text-tempura">Tempura</button>
          </router-link>
        </div>

      </div>


      <div class="container-1-right">
        <div id="slider">
          <figure>
            <img src="../assets/Kimbap.png">
            <img src="../assets/Bibimbap.png">
            <img src="../assets/BulgogiBowlChicken.png"> 
            <img src="../assets/Tempura.png">   
            <img src="../assets/Kimbap.png">
          </figure>
        </div>
      </div>

    </div>

  <router-view/>


</template>

<script>

  export default {
    name: 'HomeBody1'
  }

</script>



<style scoped>

/* for bigger screen */
@media (min-width:700px) {

  .home-notes {
    text-align: center;
    font-size: 1.7rem;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: 5vw;
    margin-bottom: 5vw;
    margin-left: 1.5vw;
    color: darkblue;
    animation: home-note-animation 2s steps(1, end) infinite;
  }

  @keyframes home-note-animation {
    50% {
      visibility: hidden;
    }
  }

/* 1st Container */
  .container-1 {
    display: grid;
    grid-template-columns: 2fr 1fr 0.1fr;
    height: 25vw;
    background-color: rgb(238, 238, 238);
    margin-top: 0.2rem;
  }



  .text-kimbap {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 1vw;
    margin-top: 6vw;
    margin-left: -30vw;
  }

  .text-bibimbap {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 1vw;
    margin-top: 2vw;
    margin-left: -10vw;
  }

  .text-bulgogi {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 1vw;
    margin-top: 2vw;
    margin-left: 10vw;
  }

  .text-tempura {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 1vw;
    margin-top: 2vw;
    margin-left: 30vw;
  }


.container-1-right {
    place-items: center;    
    width: 80%;
    height: 25vw;
    margin: auto;
  }

  #slider {
    overflow: hidden;
  }

  #slider figure {
    position: relative;
    width: 500%;
    height: 100%;
    margin: 0;
    left: 0;
    object-fit: cover;
    animation: 30s slider infinite; 
  } 

  #slider figure img {
    float: left;
    width: 20%;  /* 100 / 5 including last image (dup of image1) */ 
    transform: translate3d(0, 0, 0); /* prevents potential flickering on some browsers */
    backface-visibility: hidden;
  }


@keyframes slider {

    /* Calculation: Each image is displayed for 5s (static) and move in 1s (transition)
       Total steps are 7 (including the duplicate), but we have 6 transitions
       Each image's stop point percentage is (index * 6s / 30s * 100%)
       Move point is (index * 6s - 1s / 30s * 100%)
    */

    /* image 1: End hold at 5s */
    0% {transform: translateX(0);}
    16.67% {transform: translateX(0);} /* 5s/30s*100, stay at 0% */
    20% {transform: translateX(-20%);} /* 6s/30s*100, move to image 2 */


    /* Image 2: End hold at 11s, move to image 3 at 12s */
    36.67% {transform: translateX(-20%);} /* 11s/30s*100 */
    40% {transform: translateX(-40%);} /* 12s/30s*100 */


    /* Image 3: End hold at 17s, move to image 4 at 18s */
    56.67% {transform: translateX(-40%);} /* 17s/30s*100 */
    60% {transform: translateX(-60%);} /* 18s/30s*100 */

    /* Image 4: End hold at 23s, move to image 5 at 24s */
    76.67% {transform: translateX(-60%);} /* 23s/30s*100 */
    80% {transform: translateX(-80%);} /* 24s/30s*100 */  

    /* Image 5 (duplicate of Image 1): End hold at 29s, Infinite reset at 30s */
    96.67% {transform: translateX(-80%);} /* 29s/30s*100 */   

    100% {transform: translateX(-80%);}  /* 30s/30s*100 */
 }

}



/* for Phone */
@media (max-width:700px) {

  .home-notes {
    text-align: center;
    font-size: 1rem;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: 5vw;
    margin-bottom: 5vw;
    margin-left: 2.5vw;
    color: darkblue; 
    animation: home-note-animation 2s steps(1, end) infinite;
  }

  @keyframes home-note-animation {
    50% {
      visibility: hidden;
    }
  }


/* 1st Container */
  .container-1 {
    display: grid;
    grid-template-columns: 2fr 1fr 0.1fr;
    height: 25vw;
    background-color: rgb(238, 238, 238);
    margin-top: 1rem;
  }


  .text-kimbap {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.05rem;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: 6vw;
    margin-left: -30vw;
  }

  .text-bibimbap {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.05rem;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: 2vw;
    margin-left: -10vw;
  }

  .text-bulgogi {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.05rem;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: 2vw;
    margin-left: 10vw;
  }

  .text-tempura {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.05rem;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: 2vw;
    margin-left: 30vw;
  }


.container-1-right {
    place-items: center;    
    width: 80%;
    height: 25vw;
    margin: auto;
  }

  #slider {
    overflow: hidden;
  }

  #slider figure {
    position: relative;
    width: 500%;
    height: 100%;
    margin: 0;
    left: 0;
    object-fit: cover;
    animation: 30s slider infinite; 
  } 

  #slider figure img {
    float: left;
    width: 20%;  /* 100 / 5 including last image (dup of image1) */ 
    transform: translate3d(0, 0, 0); /* prevents potential flickering on some browsers */
    backface-visibility: hidden;
  }


@keyframes slider {

    /* Calculation: Each image is displayed for 5s (static) and move in 1s (transition)
       Total steps are 7 (including the duplicate), but we have 6 transitions
       Each image's stop point percentage is (index * 6s / 30s * 100%)
       Move point is (index * 6s - 1s / 30s * 100%)
    */

    /* image 1: End hold at 5s */
    0% {transform: translateX(0);}
    16.67% {transform: translateX(0);} /* 5s/30s*100, stay at 0% */
    20% {transform: translateX(-20%);} /* 6s/30s*100, move to image 2 */


    /* Image 2: End hold at 11s, move to image 3 at 12s */
    36.67% {transform: translateX(-20%);} /* 11s/30s*100 */
    40% {transform: translateX(-40%);} /* 12s/30s*100 */


    /* Image 3: End hold at 17s, move to image 4 at 18s */
    56.67% {transform: translateX(-40%);} /* 17s/30s*100 */
    60% {transform: translateX(-60%);} /* 18s/30s*100 */

    /* Image 4: End hold at 23s, move to image 5 at 24s */
    76.67% {transform: translateX(-60%);} /* 23s/30s*100 */
    80% {transform: translateX(-80%);} /* 24s/30s*100 */  

    /* Image 5 (duplicate of Image 1): End hold at 29s, Infinite reset at 30s */
    96.67% {transform: translateX(-80%);} /* 29s/30s*100 */   

    100% {transform: translateX(-80%);}  /* 30s/30s*100 */

 }

}

</style>